<template>
	<div class="toast-container" :class="toastClass" v-if="visible">
		<div class="toast-icon" v-if="type">
			<i class="icon-success" v-if="type === 'success'">✓</i>
			<i class="icon-error" v-if="type === 'error'">✕</i>
			<i class="icon-info" v-if="type === 'info'">i</i>
			<i class="icon-warning" v-if="type === 'warning'">!</i>
		</div>
		<div class="toast-message">{{ message }}</div>
	</div>
</template>

<script>
	// 声明一个变量用于存储单例实例
	let instance = null;

	// 定义组件选项
	const Toast = {
		name: 'Toast',
		data() {
			return {
				message: '',
				type: '', // success, error, info, warning
				visible: false,
				duration: 1500, // 默认显示时间1500ms
				timer: null
			};
		},
		computed: {
			toastClass() {
				return {
					'toast-success': this.type === 'success',
					'toast-error': this.type === 'error',
					'toast-info': this.type === 'info',
					'toast-warning': this.type === 'warning',
					'toast-show': this.visible,
					'toast-hide': !this.visible
				};
			}
		},
		methods: {
			// 显示提示
			show(options) {
				// 清除之前的定时器
				if (this.timer) {
					clearTimeout(this.timer);
				}

				// 设置提示内容和类型
				this.message = options.message || '';
				this.type = options.type || 'info';
				this.duration = options.duration || 1500;
				this.visible = true;

				// 设置自动关闭定时器
				this.timer = setTimeout(() => {
					this.hide();
				}, this.duration);
			},

			// 隐藏提示
			hide() {
				this.visible = false;
				if (this.timer) {
					clearTimeout(this.timer);
					this.timer = null;
				}
			}
		}
	};

	// 创建单例并挂载到body的函数
	export function createToast(Vue) {
		if (instance) {
			return instance;
		}

		// 创建组件构造器
		const ToastConstructor = Vue.extend(Toast);

		// 创建实例并挂载到文档中
		instance = new ToastConstructor();
		const el = document.createElement('div');
		document.body.appendChild(el);
		instance.$mount(el);

		// 定义全局方法
		Vue.prototype.$toast = {
			success(message, duration) {
				instance.show({
					type: 'success',
					message,
					duration
				});
			},
			error(message, duration) {
				instance.show({
					type: 'error',
					message,
					duration
				});
			},
			info(message, duration) {
				instance.show({
					type: 'info',
					message,
					duration
				});
			},
			warning(message, duration) {
				instance.show({
					type: 'warning',
					message,
					duration
				});
			}
		};

		return instance;
	}

	// 导出组件本身（用于可能的局部注册）
	export default Toast;
</script>

<style lang="less" scoped>
	.toast-container {
		position: fixed;
		top: 20px;
		left: 50%;
		transform: translateX(-50%);
		padding: 12px 20px;
		border-radius: 4px;
		color: #fff;
		font-size: 14px;
		display: inline-flex;
		align-items: center;
		z-index: 9999;
		transition: all 0.3s ease;
		opacity: 0;
		pointer-events: none;

		&.toast-show {
			opacity: 1;
			top: 30px;
		}

		&.toast-hide {
			opacity: 0;
			top: 20px;
		}
	}

	.toast-icon {
		margin-right: 8px;
		font-size: 16px;
		width: 20px;
		height: 20px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
	}

	.icon-success {
		background-color: rgba(255, 255, 255, 0.2);
	}

	.icon-error {
		background-color: rgba(255, 255, 255, 0.2);
	}

	.icon-info {
		background-color: rgba(255, 255, 255, 0.2);
	}

	.icon-warning {
		background-color: rgba(255, 255, 255, 0.2);
	}

	.toast-success {
		background-color: #52c41a;
		box-shadow: 0 2px 8px rgba(82, 196, 26, 0.3);
	}

	.toast-error {
		background-color: #f5222d;
		box-shadow: 0 2px 8px rgba(245, 34, 45, 0.3);
	}

	.toast-info {
		background-color: #1890ff;
		box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
	}

	.toast-warning {
		background-color: #faad14;
		box-shadow: 0 2px 8px rgba(250, 173, 20, 0.3);
	}

	.toast-message {
		line-height: 1.5;
	}
</style>


<!-- 
// 成功提示
this.$toast.success('注册成功！');

// 错误提示
this.$toast.error('操作失败，请重试');

// 信息提示
this.$toast.info('请检查输入内容');

// 警告提示
this.$toast.warning('密码即将过期');

// 自定义显示时间（如2000ms）
this.$toast.success('提交成功', 2000); -->